import { render, staticRenderFns } from "./FeaturedProjects.vue?vue&type=template&id=ead8f584"
import script from "./FeaturedProjects.vue?vue&type=script&lang=js"
export * from "./FeaturedProjects.vue?vue&type=script&lang=js"
import style0 from "./FeaturedProjects.vue?vue&type=style&index=0&id=ead8f584&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports